import React from 'react';


export default class NotFoundComponent extends React.Component {
  render(){
      return(<h1>PAGE NOT FOUND!!!!It Seems that you are checking wrong URL!!!!!!</h1>)
  }
}